<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="violationTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="alarmStatus" slot-scope="data">
          <el-tag type="success" v-if="data.row.alarmStatus === '00000000'">正常</el-tag>
          <el-tag v-else-if="data.row.alarmStatus === '00000001'">满溢</el-tag>
          <el-tag v-else-if="data.row.alarmStatus === '00000016'">异常</el-tag>
          <el-tag v-else>已处理</el-tag>
        </template>
        <template slot="tableTopCustom">
          <div class="table-list-desc">共有{{form.formResult.total}} 台设备</div>
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <el-dialog title="视频" :visible.sync="openVideo" width="80%" append-to-body @close="handleClose">
      <video ref="videoPlayer" :src="this.dataForm.path" v-if="this.dataForm != null && openVideo" controls></video>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      openVideo: false,
      dataForm: null,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_RECYCLINGBIN_LIST',
        formComponent: {
          view: { type: 'component', componentName: 'RecyclingBin-view', value: 'queryRecyclingBinDetailData' },
          list: { type: 'default', value: '/modules/ablHardware/dataList' }
        },
        formInputsData: [
          { name: '箱体名称', key: 'boxName', value: '', type: 'text' },
          { name: 'SN', key: 'sn', value: '', type: 'text' },
          { name: '摄像头序列号', key: 'cam', value: '', type: 'text' },
          { name: '状态',
            key: 'alarmStatus',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '正常', value: '00000000' },
              { label: '满溢', value: '00000001' },
              { label: '异常', value: '00000016' }
            ] }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/ablHardware/exportExcel',
          fileName: '回收箱列表',
          permission: 'EXPORT' },
        { name: '导入', key: 'IMPORT', action: 'IMPORT', hidden: false, type: 'IMPORT', url: window.wtConst.BASE_API + '/modules/ablHardware/importExcel', permission: 'IMPORT' }],
        formTableData: [
          { name: '公司名称', key: 'companyName' },
          { name: '箱体名称', key: 'boxName', type: 'text' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '首开资产码', key: 'assetCode', type: 'text' },
          { name: '箱地址', key: 'addr', type: 'text' },
          { name: '摄像头序列号', key: 'cam', type: 'text' },
          { name: '状态', key: 'alarmStatus', type: 'custom' },
          { name: '到期时间', key: 'expiryDate', type: 'text' },
          { name: '投递单价(元)', key: 'unitPrice', type: 'text' },
          { name: '当前重量(Kg)', key: 'weight', type: 'text' },
          { name: '开箱费用', key: 'upMoney', type: 'text' },
          { name: '近30天', key: 'weight30', type: 'text' },
          { name: '近60天', key: 'weight60', type: 'text' },
          { name: '近90天', key: 'weight90', type: 'text' }],
        formTableButtonsData: [
          { name: '当前播放', key: 'VIDEO', action: 'VIDEO', permission: 'VIDEO', className: 'primary', hidden: true },
          { name: '清运记录', key: 'TRANSPORTATION', action: 'TRANSPORTATION', permission: 'TRANSPORTATION', className: 'primary' },
          { name: '投递记录', key: 'DELIVERYRECORD', action: 'DELIVERYRECORD', permission: 'DELIVERYRECORD', className: 'primary' },
          { name: '查看详情', key: 'VIEW', action: 'VIEW', permission: 'VIEW', className: 'primary' }
        ],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: false, buttonMinWidth: 270, buttonWidth: 270 }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        this.dataForm = null
        if (data.item.action === 'TRANSPORTATION') {
          this.$router.push({
            name: 'transportationList',
            query: { sn: data.row.sn }
          })
        } else if (data.item.action === 'DELIVERYRECORD') {
          this.$router.push({
            name: 'deliveryRecordList',
            query: { sn: data.row.sn }
          })
        } else if (data.item.action === 'VIDEO') {
          this.dataForm = data.row
          this.openVideo = true
        }
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    },
    handleClose() {
      this.$refs.videoPlayer.pause() // 停止视频播放
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
